<template>
	<div class="min-h-screen flex flex-col bg-fixed bg-repeat-x bg-bottom relative" :style="`background-image: linear-gradient(to top, #ffffff66, #ffffff 60%), url('${require('@/assets/rvquiz/background.svg')}'), linear-gradient(to top, #f01449, #ffffff 60%);`">
		<header class="py-2 fixed top-0 w-full z-10 bg-white shadow">
			<div class="flex justify-between items-center px-4 container mx-auto">
				<div class="flex-1 mx-auto">
					<img class="mr-auto h-6 lg:h-8" :src="require('@/assets/dish-outdoors.svg')">
				</div>
				<p class="hidden sm:block flex-1 text-center font-semibold text-dish-red text-xl leading-none md:text-2xl lg:text-3xl" v-if="currentQuestion !== null && !showDemographicQuestions">{{ percentage }}% Complete</p>
				<div class="flex-1 flex">
					<div class="ml-auto">
						<a href="tel:18004721039" class="ml-auto text-white bg-dish-red p-1 rounded flex items-center sm:pr-3 sm:pl-2">
							<svg class="h-6 inline-block" fill="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" stroke="none" viewBox="0 0 24 24">
								<path d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"></path>
							</svg>
							<span class="hidden sm:inline-block ml-2 md:text-lg leading-none">1-800-472-1039</span>
						</a>
					</div>
				</div>
			</div>
		</header>
		<main class="flex-grow flex items-center relative pt-10 sm:pt-12" style="backdrop-filter: blur(2px);">
			<div class="container mx-auto px-4">
				<div class="py-10 text-gray-800" v-if="result !== null">
					<img class="w-full max-w-sm -mt-4 sm:w-auto sm:max-w-full sm:h-48 mx-auto lg:hidden" :src="require('@/assets/rvquiz/logo.png')">

					<div class="shadow-md rounded bg-white max-w-sm mx-auto mt-4 lg:hidden">
						<img class="w-full" :src="result.images.mobile">
						<div class="py-4 px-4">
							<h2 class="font-bold text-4xl text-center leading-none">{{ result.name }}</h2>

							<p class="mt-2">{{ result.personality }}</p>

							<a class="mx-auto block w-32 text-center bg-dish-red text-white py-1 px-4 font-semibold rounded mt-4 tracking-wide" :href="result.learn">Learn More</a>

							<a class="mx-auto mt-8 block" :href="result.product"><img class="mx-auto" :src="result.images.product"></a>

							<h3 class="mt-4 text-center text-2xl font-bold leading-tight">{{ result.subtitle }}</h3>
							<p class="mt-2">{{ result.addition }}</p>

							<a class="mx-auto block w-32 text-center bg-dish-red text-white py-1 px-4 font-semibold rounded mt-4 tracking-wide" :href="result.product">Buy Now</a>
						</div>
					</div>
					<div class="shadow-md rounded bg-white max-w-4xl mx-auto hidden lg:flex xl:max-w-5xl">
						<div class="w-2/5 flex-shrink-0 bg-center bg-cover xl:w-1/3" :style="`background-image: url('${result.images.desktop}');`">
							<div class="py-4 px-2 relative">
								<div class="absolute inset-0 bg-white opacity-75"></div>
								<img class="w-full mx-auto relative" :src="require('@/assets/rvquiz/logo.png')">
							</div>
						</div>
						<div class="py-4 px-8 flex-grow">
							<h2 class="font-bold text-4xl leading-none xl:text-5xl">{{ result.name }}</h2>

							<p class="mt-4 text-lg xl:text-xl">{{ result.personality }}</p>

							<a class="mt-4 mx-auto block w-40 text-center bg-dish-red text-white py-1 px-4 font-semibold text-lg rounded tracking-wide" :href="result.learn">Learn More</a>

							<div class="flex items-center mt-8 flex-col-reverse xl:flex-row">
								<div class="flex-shrink mt-4 xl:mt-0">
									<h3 class="text-2xl font-bold leading-tight xl:tracking-tight">{{ result.subtitle }}</h3>
									<p class="mt-2 text-lg xl:text-xl">{{ result.addition }}</p>
								</div>
								
								<div class="flex-shrink-0 xl:ml-4">
									<a class="block" :href="result.product"><img :src="result.images.product"></a>
								</div>
							</div>

							<a class="mt-4 mx-auto block w-40 text-center bg-dish-red text-white py-1 px-4 font-semibold text-lg rounded tracking-wide" :href="result.product">Buy Now</a>
						</div>
					</div>
					<div class="flex justify-center mt-8">
						<a class="mx-2" href="https://facebook.com/sharer/sharer.php?u=https%3A%2F%2Fdishoutdoors.com%2Frv-quiz" target="_blank" rel="noopener">
							<div class="rounded p-2" style="background-color: #3b5998;">
								<div aria-hidden="true" class="fill-current text-white">
									<svg class="h-5 w-5" stroke="none" viewBox="0 0 24 24"><path d="M18.77 7.46H14.5v-1.9c0-.9.6-1.1 1-1.1h3V.5h-4.33C10.24.5 9.5 3.44 9.5 5.32v2.15h-3v4h3v12h5v-12h3.85l.42-4z"/></svg>
								</div>
							</div>
						</a>
						<a class="mx-2" href="https://twitter.com/intent/tweet/?text=Which%20RV%20are%20you%3F&amp;url=https%3A%2F%2Fdishoutdoors.com%2Frv-quiz" target="_blank" rel="noopener">
							<div class="rounded p-2" style="background-color: #55acee;">
								<div aria-hidden="true" class="fill-current text-white">
									<svg class="h-5 w-5" stroke="none" viewBox="0 0 24 24"><path d="M23.44 4.83c-.8.37-1.5.38-2.22.02.93-.56.98-.96 1.32-2.02-.88.52-1.86.9-2.9 1.1-.82-.88-2-1.43-3.3-1.43-2.5 0-4.55 2.04-4.55 4.54 0 .36.03.7.1 1.04-3.77-.2-7.12-2-9.36-4.75-.4.67-.6 1.45-.6 2.3 0 1.56.8 2.95 2 3.77-.74-.03-1.44-.23-2.05-.57v.06c0 2.2 1.56 4.03 3.64 4.44-.67.2-1.37.2-2.06.08.58 1.8 2.26 3.12 4.25 3.16C5.78 18.1 3.37 18.74 1 18.46c2 1.3 4.4 2.04 6.97 2.04 8.35 0 12.92-6.92 12.92-12.93 0-.2 0-.4-.02-.6.9-.63 1.96-1.22 2.56-2.14z"/></svg>
								</div>
							</div>
						</a>
						<a class="mx-2" href="mailto:?subject=Which%20RV%20are%20you%3F&amp;body=https%3A%2F%2Fdishoutdoors.com%2Frv-quiz" target="_self" rel="noopener">
							<div class="rounded p-2" style="background-color: #777777;">
								<div aria-hidden="true" class="fill-current text-white">
									<svg class="h-5 w-5" stroke="none" viewBox="0 0 24 24"><path d="M22 4H2C.9 4 0 4.9 0 6v12c0 1.1.9 2 2 2h20c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zM7.25 14.43l-3.5 2c-.08.05-.17.07-.25.07-.17 0-.34-.1-.43-.25-.14-.24-.06-.55.18-.68l3.5-2c.24-.14.55-.06.68.18.14.24.06.55-.18.68zm4.75.07c-.1 0-.2-.03-.27-.08l-8.5-5.5c-.23-.15-.3-.46-.15-.7.15-.22.46-.3.7-.14L12 13.4l8.23-5.32c.23-.15.54-.08.7.15.14.23.07.54-.16.7l-8.5 5.5c-.08.04-.17.07-.27.07zm8.93 1.75c-.1.16-.26.25-.43.25-.08 0-.17-.02-.25-.07l-3.5-2c-.24-.13-.32-.44-.18-.68s.44-.32.68-.18l3.5 2c.24.13.32.44.18.68z"/></svg>
								</div>
							</div>
						</a>
						<a class="mx-2" href="https://pinterest.com/pin/create/button/?url=https%3A%2F%2Fdishoutdoors.com%2Frv-quiz&amp;media=https%3A%2F%2Fdishoutdoors.com%2Frv-quiz&amp;description=Which%20RV%20are%20you%3F" target="_blank" rel="noopener">
							<div class="rounded p-2" style="background-color: #bd081c;">
								<div aria-hidden="true" class="fill-current text-white">
									<svg class="h-5 w-5" stroke="none" viewBox="0 0 24 24"><path d="M12.14.5C5.86.5 2.7 5 2.7 8.75c0 2.27.86 4.3 2.7 5.05.3.12.57 0 .66-.33l.27-1.06c.1-.32.06-.44-.2-.73-.52-.62-.86-1.44-.86-2.6 0-3.33 2.5-6.32 6.5-6.32 3.55 0 5.5 2.17 5.5 5.07 0 3.8-1.7 7.02-4.2 7.02-1.37 0-2.4-1.14-2.07-2.54.4-1.68 1.16-3.48 1.16-4.7 0-1.07-.58-1.98-1.78-1.98-1.4 0-2.55 1.47-2.55 3.42 0 1.25.43 2.1.43 2.1l-1.7 7.2c-.5 2.13-.08 4.75-.04 5 .02.17.22.2.3.1.14-.18 1.82-2.26 2.4-4.33.16-.58.93-3.63.93-3.63.45.88 1.8 1.65 3.22 1.65 4.25 0 7.13-3.87 7.13-9.05C20.5 4.15 17.18.5 12.14.5z"/></svg>
								</div>
							</div>
						</a>
					</div>
				</div>

				<div class="text-center text-gray-800 py-10 max-w-4xl mx-auto" v-else-if="currentQuestion === null">
					<img class="w-full max-w-sm sm:w-auto sm:max-w-full sm:h-48 mx-auto" :src="require('@/assets/rvquiz/logo.png')">

					<div class="shadow-md mt-2 rounded overflow-hidden sm:mt-4">
						<img class="w-full h-48 object-cover sm:object-none sm:h-auto" :src="require('@/assets/rvquiz/start.jpg')">
						<div class="bg-white py-4 px-8 md:px-16">
							<h1 class="text-4xl font-bold leading-none mx-auto md:text-5xl">Which RV are you?</h1>
							<p class="text-lg mt-2 mx-auto md:text-xl md:max-w-3xl">We know you are the adventuring type but how do you REALLY roll? Find out if you're a class act or a camper with no commitments. Just answer a few fun questions.</p>

							<button @click="currentQuestion = 0" class="bg-dish-red text-white py-2 px-8 font-semibold text-lg rounded mt-6 tracking-wide">Let's Roll</button>
						</div>
					</div>
				</div>

				<div class="py-10 max-w-4xl mx-auto" v-else-if="showDemographicQuestions">
					<h2 class="text-center font-semibold text-gray-800 text-4xl leading-tight">Hit The Breaks!</h2>
					<p class="text-center text-lg mt-2 max-w-xs mx-auto sm:text-2xl sm:leading-tight sm:max-w-md">Before you roll into your next adventure, we want to meet you.</p>

					<hubspot-form formId="c77aaf41-2e1b-4679-aa02-0e053ed466cd">
						<form @submit.prevent="handleSubmit(submit)" class="mt-4 rounded sm:mt-8 shadow-md bg-white py-4 px-4 mx-auto max-w-xs" slot-scope="{ submitting, submit, error }">
							<div>
								<label class="font-semibold uppercase text-sm text-gray-700">First Name</label>
								<input v-model="first" type="text" required autocomplete="given-name" class="leading-tight shadow-inner rounded border w-full p-1">
							</div>
							<div class="mt-4">
								<label class="font-semibold uppercase text-sm text-gray-700">Email</label>
								<input v-model="email" type="email" required autocomplete="email" class="leading-tight shadow-inner rounded border w-full p-1">
							</div>
							<div class="mt-4">
								<label class="font-semibold uppercase text-sm text-gray-700">Age Range</label>
								<select name="age" required v-model="age" class="block leading-tight shadow-inner rounded border w-full p-1">
									<option v-for="option in ['18-34', '35-49', '50-64', '65+']" :key="option" :value="option">{{ option }}</option>
								</select>
							</div>
							<div class="mt-4 pt-4 border-t" @click.stop>
								<p class="font-semibold text-gray-700 text-center">Are you a current DISH Subscriber?</p>

								<div class="flex justify-center mt-2">
									<div class="w-16 mx-2 shadow border rounded py-2 text-center font-semibold tracking-wider relative" :class="{ 'bg-dish-red text-white border-dish-red': subscriber === value}" @click="subscriber = value" v-for="value in ['Yes', 'No']" :key="value">
										<div class="absolute inset-0">
											<input name="subscriber" class="absolute bottom-0" type="radio" required v-model="subscriber" :value="value">
										</div>
										<div class="absolute inset-0 flex items-center justify-center" :class="subscriber === value ? 'bg-dish-red' : 'bg-white'">
											<label>{{ value }}</label>
										</div>
										<label class="invisible">{{ value }}</label>
									</div>
								</div>
							</div>

							<div class="mt-4 pt-4 border-t">
								<button type="submit" class="flex justify-center items-center bg-dish-red text-white py-2 px-8 font-semibold text-center rounded w-full">
									<template v-if="submitting">
										<p>Submitting...</p>
									</template>
									<template v-else>
										<span>Show Me How I Roll</span>
										<svg class="h-4 w-4 ml-1" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round">
											<line x1="5" y1="12" x2="19" y2="12"></line>
											<polyline points="12 5 19 12 12 19"></polyline>
										</svg>
									</template>
								</button>
							</div>

							<p class="text-center text-dish-red font-bold mt-4 leading-snug tracking-wide" v-if="error">There was an issue with your submission. Please verify your information and try again.</p>
						</form>
					</hubspot-form>
				</div>

				<div class="py-10" v-else>
					<h2 class="text-center font-semibold text-gray-800 text-2xl leading-tight sm:text-3xl md:text-4xl">{{ question.question }}</h2>

					<ul class="mt-6 w-full mx-auto max-w-xs sm:mt-8 md:max-w-full md:flex md:-ml-4 md:flex-wrap md:justify-center md:mt-2">
						<li class="mt-4 sm:mt-6 md:w-1/3 md:pl-4 lg:w-1/5" v-for="{ answer, value, image } in question.answers" :key="answer">
							<button class="w-full h-full leading-snug rounded cursor-pointer overflow-hidden shadow bg-white text-gray-800" @click="select(value)">
								<div class="w-full h-full flex flex-col">
									<div class="w-full h-48 relative xl:h-48">
										<div class="absolute inset-0 flex justify-center items-center">
											<div class="h-12 w-12 rounded-full border-8 spinning" :style="`border-color: #f0144655; border-top-color: #f01446; animation-delay:-${Math.floor(Math.random() * 1000)}ms`"></div>
										</div>
										<img class="w-full h-full object-center object-cover relative" :src="image">
									</div>
									<p class="py-2 px-4 my-auto sm:text-lg xl:py-3 xl:py-6 xl:text-xl">{{ answer }}</p>
								</div>
							</button>
						</li>
					</ul>

					<div class="-mx-4 mt-10 -mb-10 px-4 sticky bottom-0 py-4 flex items-center justify-center shadow bg-white sm:hidden">
						<p class="text-dish-red font-bold text-xl flex-1 text-center">{{ percentage }}% Complete</p>
					</div>
				</div>
			</div>
		</main>
	</div>
</template>

<script>
	import objectFitImages from 'object-fit-images'

	import HubspotForm from '@/components/HubspotForm'
	
	const answers = {
		TRUCK: 0,
		WHEEL: 1,
		POPUP: 2,
		TRAILER: 3,
		CLASSC: 4,
		CLASSB: 5,
		CLASSA: 6,
	}

	export default {
		components: {
			HubspotForm,
		},

		computed: {
			question() {
				return this.questions[this.currentQuestion]
			},

			phoneUrl() {
				return `tel:${this.phoneNumber}`
			},

			percentage() {
				const length = this.questions.length
				
				return 100 - Math.floor((length - this.currentQuestion) / length * 100)
			}
		},

		data() {
			return {
				phoneNumber: '1-800-867-5309',

				result: null,

				showDemographicQuestions: false,
				first: null,
				email: null,
				age: null,
				subscriber: null,

				currentQuestion: null,
				questions: [
					{ question: 'When you go on an adventure you go:', answers: [
						{ answer: 'Completely off the grid.', value: answers.TRUCK, image: require('@/assets/rvquiz/questions/Completely-Off-The-Grid.jpg') },
						{ answer: 'Look for a quiet spot.', value: answers.TRAILER, image: require('@/assets/rvquiz/questions/Look-For-A-Quiet-Spot.jpg') },
						{ answer: `I don't "adventure", I camp.`, value: answers.POPUP, image: require('@/assets/rvquiz/questions/I-Dont-Adventure-I-Camp.jpg') },
						{ answer: 'Somewhere not rugged, but remote', value: answers.CLASSC, image: require('@/assets/rvquiz/questions/Somewhere-Not-Rugged-But-Remote.jpg') },
						{ answer: 'Wherever the road takes me.', value: answers.CLASSB, image: require('@/assets/rvquiz/questions/Where-The-Road-Takes-Me.jpg') },
					], selectedAnswer: null},

					
					{ question: 'You only get to pack ONE bag, in there is:', answers: [
						{ answer: 'As much as possible, and then some. Also a carry-on.', value: answers.CLASSA, image: require('@/assets/rvquiz/questions/As-Much-As-Possible.jpg') },
						{ answer: 'The essentials and quite a few comforts.', value: answers.CLASSC, image: require('@/assets/rvquiz/questions/Essentials-And-A-Few-Comforts.jpg') },
						{ answer: 'Just about as much as I can reasonably pack.', value: answers.WHEEL, image: require('@/assets/rvquiz/questions/Reasonably-Pack.jpg') },
						{ answer: 'T.P. , toothpaste, toothbrush, undies, and survival gear. Packed!', value: answers.TRUCK, image: require('@/assets/rvquiz/questions/Survival-Gear-Packed.jpg') },
						{ answer: "Depends on where I'm going.", value: answers.TRAILER, image: require('@/assets/rvquiz/questions/Depends-On-Where-Im-Going.jpg') },
					], selectedAnswer: null},

					
					{ question: 'You enjoy having friends with you:', answers: [
						{ answer: 'Yeah, sometimes.', value: answers.WHEEL, image: require('@/assets/rvquiz/questions/Yeah-Sometimes.jpg') },
						{ answer: 'No, go away.', value: answers.TRUCK, image: require('@/assets/rvquiz/questions/No-Go-Away.jpg') },
						{ answer: 'I enjoy having my good friends with me.', value: answers.TRAILER, image: require('@/assets/rvquiz/questions/Enjoy-Having-My-Good-Friends-With-Me.jpg') },
						{ answer: 'A quick visit is nice!', value: answers.CLASSB, image: require('@/assets/rvquiz/questions/Quick-Visit-Is-Nice.jpg') },
						{ answer: "Eh, doesn't really matter", value: answers.POPUP, image: require('@/assets/rvquiz/questions/Not-Really-No.jpg') },
					], selectedAnswer: null},

					
					{ question: 'Is bigger "better"?', answers: [
						{ answer: 'Of course! The bigger, the better!', value: answers.CLASSA, image: require('@/assets/rvquiz/questions/Of-Course-Bigger-The-Better.jpg') },
						{ answer: "On occassion, that's correct.", value: answers.TRAILER, image: require('@/assets/rvquiz/questions/On-Occassion.jpg') },
						{ answer: "No, it's not the size of the camper, it's how you use it.", value: answers.CLASSB, image: require('@/assets/rvquiz/questions/How-You-Use-It.jpg') },
						{ answer: 'Size matters, most of the time.', value: answers.WHEEL, image: require('@/assets/rvquiz/questions/Size-Matters-Most-Of-The-Time.jpg') },
						{ answer: "I'd agree.", value: answers.CLASSC, image: require('@/assets/rvquiz/questions/Id-Agree.jpg') },
					], selectedAnswer: null},

					
					{ question: 'If you go camping, do you enjoy being as close to nature as possible?', answers: [
						{ answer: 'Most certainly!', value: answers.TRUCK, image: require('@/assets/rvquiz/questions/Most-Certainly.jpg') },
						{ answer: 'I suppose you could say that.', value: answers.POPUP, image: require('@/assets/rvquiz/questions/Enjoy-Modern-Convienences.jpg') },
						{ answer: 'Within reason.', value: answers.TRAILER, image: require('@/assets/rvquiz/questions/Within-Reason.jpg') },
						{ answer: 'As long as it stays on the other side of the screen door.', value: answers.CLASSA, image: require('@/assets/rvquiz/questions/Other-Side.jpg') },
						{ answer: 'Yes, but I enjoy my modern day convienences.', value: answers.WHEEL, image: require('@/assets/rvquiz/questions/I-Suppose-You-Could-Say-That.jpg') },
					], selectedAnswer: null},

					
					{ question: 'What kind of footware would you pick?', answers: [
						{ answer: 'Hiking boots.', value: answers.CLASSB, image: require('@/assets/rvquiz/questions/Hiking-Boots.jpg') },
						{ answer: 'Flip flops or sandals.', value: answers.CLASSA, image: require('@/assets/rvquiz/questions/Flip-Flops.jpg') },
						{ answer: 'Tennis shoes.', value: answers.WHEEL, image: require('@/assets/rvquiz/questions/Tennis-Shoes.jpg') },
						{ answer: 'All weather and all terrain boots.', value: answers.TRUCK, image: require('@/assets/rvquiz/questions/All-Terrain-Boots.jpg') },
						{ answer: 'Anything comfortable.', value: answers.CLASSC, image: require('@/assets/rvquiz/questions/Anything-Comfortable.jpg') },
					], selectedAnswer: null},

					
					{ question: 'The people I surround myself with are:', answers: [
						{ answer: 'Flexible, but still like modern day convienences.', value: answers.TRAILER, image: require('@/assets/rvquiz/questions/Flexible.jpg') },
						{ answer: 'They might be a little needy...', value: answers.CLASSA, image: require('@/assets/rvquiz/questions/They-Might-Be-A-Little-Needy.jpg') },
						{ answer: `People that enjoy convienences but don't need to be "wowed".`, value: answers.WHEEL, image: require('@/assets/rvquiz/questions/People-That-Enjoy-Convienences.jpg') },
						{ answer: 'Those who enjoy luxury and the little things.', value: answers.CLASSC, image: require('@/assets/rvquiz/questions/Luxury.jpg') },
						{ answer: `I don't like to... surround myself with "people".`, value: answers.POPUP, image: require('@/assets/rvquiz/questions/People.jpg') },
					], selectedAnswer: null},
				],
			}
		},

		methods: {
			select(value) {
				this.questions[this.currentQuestion].selectedAnswer = value

				if (this.currentQuestion !== this.questions.length - 1) {
					this.currentQuestion++
					return
				}

				this.showDemographicQuestions = true
			},

			handleSubmit(submit) {
				const { index: result } = this.questions.map(({ selectedAnswer }) => selectedAnswer).reduce((total, answer) => {
					total[answer]++

					return total
				}, new Array(this.questions.length).fill(0)).reduce((accumulator, amount, index) => {
					if (amount > accumulator.max) {
						accumulator.index = index
						accumulator.max = amount
					}

					return accumulator
				}, { max: -1, index: -1 })
				
				submit([
					{ name: 'firstname', value: this.first },
					{ name: 'email', value: this.email },
					{ name: 'age_range', value: this.age },
					{ name: 'are_you_a_current_dish_subscriber_', value: this.subscriber },
					{ name: 'what_rv_are_you_quiz_result', value: [
						'Truck Camper',
						'5th Wheel',
						'Pop-Up',
						'Travel Trailer',
						'Class C',
						'Class B',
						'Class A',
					][result] }
				]).then(() => {
					if (window.fbq) {
						window.fbq('track', 'Lead')
					}
	
					this.result = [
						{ 
							name: 'You Are A Camper with No commitments',
							personality: "You're looking for a rugged outdoor experience that connects you with nature no matter what the terrain. There also isn't may people you're bringing with you, if anyone at all. You are simple so you want a comfortable place to relax without all the bells and whistles. You are a camper with no commitments!",
							learn: 'https://get.dishformyrv.com/outdoor-satellite-tv/dish-satellite-rv-service',
							subtitle: 'ADD the No Commitment Starter Package to your RV experience.',
							addition: 'With the DISH Playmaker, no matter where you roll up to, you can easily set up and be watching HD TV in just minutes.',
							product: 'https://www.dishformyrv.com/new-dish-playmaker-bundle-with-wally/',
							images: {
								desktop: require('@/assets/rvquiz/results/Truck-Camper-Desktop.jpg'),
								mobile: require('@/assets/rvquiz/results/Truck-Camper-Mobile.jpg'),
								product: require('@/assets/rvquiz/results/Playmaker.png'),
							},
						}, { 
							name: 'You Are A Friendly 5th Wheeler',
							personality: "You got friends in high AND low places. Wherever you travel, you value convienence and luxury with enough space for your friends, and family. You like to comfortably enjoy the outdoors the same way you do at home. With accomodations like these and friends, anywhere can be your new home! You Are A Friendly 5th Wheeler. (and that's a great thing!)",
							learn: 'https://get.dishformyrv.com/traveltrailer',
							subtitle: 'ADD the Friendly 5th Wheeler package to your RV experience.',
							addition: 'The best part of the Tailgater Pro, everyone stays friends because it works for watching on two TVs  at the same time. Everyone wins!',
							product: 'https://www.dishformyrv.com/dish-tailgater-pro-satellite-antenna-bundle-with-wally/',
							images: {
								desktop: require('@/assets/rvquiz/results/5th-Wheel-Desktop.jpg'),
								mobile: require('@/assets/rvquiz/results/5th-Wheel-Mobile.jpg'),
								product: require('@/assets/rvquiz/results/Tailgater-Pro.png'),
							},
						}, { 
							name: 'You Are A Tent With Benefits',
							personality: "You are easy-going and don't need a lot of space. Your style is to hit the road without planning. You love connecting with nature but having a comfortable place to relax when you want to windown. Enjoy the best of both worlds in a pop up camper. It's like a tent with benefits!",
							learn: 'https://get.dishformyrv.com/outdoor-satellite-tv/dish-satellite-rv-service',
							subtitle: 'ADD the Tent with Benefits Starter Pack to your RV experience.',
							addition: 'With the DISH Playmaker relax inside or even propped on a tripod next to the fire and watch your favorite shows and movies to windown.',
							product: 'https://www.dishformyrv.com/new-dish-playmaker-bundle-with-wally/',
							images: {
								desktop: require('@/assets/rvquiz/results/Pop-Up-Camper-Desktop.jpg'),
								mobile: require('@/assets/rvquiz/results/Pop-Up-Camper-Mobile.jpg'),
								product: require('@/assets/rvquiz/results/Playmaker.png'),
							},
						}, { 
							name: 'You Are Ready To Hitch & Roll',
							personality: "Take your home where YOU want to go! You want to enjoy time with your favorite travel companions and create memories but also have your own space to relax like you do at home. You are invested in the camping lifestyle but need the ability to get up and go when you want! You are ready to hitch and roll!",
							learn: 'https://get.dishformyrv.com/traveltrailer',
							subtitle: 'ADD the Ready To Hitch & Roll package to your RV experience.',
							addition: "When you have a TV in two spaces, it's great to have The Tailgater Pro that supports both. Enjoy different shows in your own spaces.",
							product: 'https://www.dishformyrv.com/dish-tailgater-pro-satellite-antenna-bundle-with-wally/',
							images: {
								desktop: require('@/assets/rvquiz/results/Travel-Trailer-Desktop.jpg'),
								mobile: require('@/assets/rvquiz/results/Travel-Trailer-Mobile.jpg'),
								product: require('@/assets/rvquiz/results/Tailgater-Pro.png'),
							},
						}, { 
							name: 'You Are Classy and Conventional',
							personality: "You want to balance luxury and efficiency. Quality time with your family and friends is important so you want to park and enjoy when you are traveling. You don't need the biggest but you enjoy being comfortable with modern day convienences. Get the best of both worlds with your mini motorized home. You are Classy AND Conventional!",
							learn: 'https://get.dishformyrv.com/outdoor-satellite-tv/dish-satellite-rv-service',
							subtitle: 'ADD The Classy & Conventional package to your RV experience.',
							addition: "The Tailgater Pro is classy with it's clear dome AND conventional with the flexibility to mount or not. Enjoy live news and the family favorites.",
							product: 'https://www.dishformyrv.com/dish-tailgater-pro-satellite-antenna-bundle-with-wally/',
							images: {
								desktop: require('@/assets/rvquiz/results/Class-C-Desktop.jpg'),
								mobile: require('@/assets/rvquiz/results/Class-C-Mobile.jpg'),
								product: require('@/assets/rvquiz/results/Tailgater-Pro.png'),
							},
						}, { 
							name: 'You Are A Free Roller',
							personality: "You enjoy both efficiency and an on-the-go camping experience. Being flexible where you set up is a priority. You need the freedom to stay for a bit with the luxury of hitting the road with a couple close people along for the ride at any moment. You are a dual-living, free-roller.",
							learn: 'https://get.dishformyrv.com/outdoor-satellite-tv/dish-satellite-rv-service',
							subtitle: 'ADD the Free Roller Package to your RV experience.',
							addition: 'Simple and efficient, the DISH Playmaker fits your style. Set it up and run it right into your vehicle for live news and your favorite shows.',
							product: 'https://www.dishformyrv.com/new-dish-playmaker-bundle-with-wally/',
							images: {
								desktop: require('@/assets/rvquiz/results/Class-B-Desktop.jpg'),
								mobile: require('@/assets/rvquiz/results/Class-B-Mobile.jpg'),
								product: require('@/assets/rvquiz/results/Playmaker.png'),
							},
						}, { 
							name: 'You Are A Class Act',
							personality: `You enjoy the finer things in life with friends and family. Waking up to new scenes is your jam but you love the luxury of it "feeling like home".You're well connected to nature AND to modern day luxuries. After enjoying nature you want to head back to your "just like home" RV. You are an all-in-one kind of class act!`,
							learn: 'https://get.dishformyrv.com/dish-satellite-rv-motorhome',
							subtitle: 'ADD The Class Act Package to your RV experience!',
							addition: 'Watch TV wherever you travel and entertain your "back seat drivers" while on the road with our T4 In-Motion antenna from Winegard.',
							product: 'https://www.dishformyrv.com/winegard-roadtrip-t4-in-motion-antenna-bundle-with-wally/',
							images: {
								desktop: require('@/assets/rvquiz/results/Class-A-Desktop.jpg'),
								mobile: require('@/assets/rvquiz/results/Class-A-Mobile.jpg'),
								product: require('@/assets/rvquiz/results/T4.png'),
							},
						},
					][result]
				})
			},
		},

		mounted() {
			objectFitImages()
		},
	}
</script>

<style scoped>
	.object-cover.object-center {
		@apply object-cover object-center;
	}

	.spinning {
		animation: spinning 1s linear infinite both;
	}

	@keyframes spinning {
		from {
			transform: rotate(0deg);
		}

		to {
			transform: rotate(360deg);
		}
	}
</style>
